export default "__VITE_ASSET__BrT4BRZg__"